// src/components/ui/toaster.js
import React, { useState, useEffect } from "react";
import { useAppContext } from "../../context/AppContext";
import { X, AlertCircle, CheckCircle, Info } from "lucide-react";

export function Toaster() {
  const { state } = useAppContext();
  const { notification } = state;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (notification) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [notification]);

  if (!visible || !notification) return null;

  const { message, type = "info" } = notification;

  const getIcon = () => {
    switch (type) {
      case "success":
        return <CheckCircle className="h-5 w-5 text-green-500" />;
      case "error":
        return <AlertCircle className="h-5 w-5 text-red-500" />;
      case "info":
      default:
        return <Info className="h-5 w-5 text-blue-500" />;
    }
  };

  const getBgColor = () => {
    switch (type) {
      case "success":
        return "bg-green-50 border-green-200";
      case "error":
        return "bg-red-50 border-red-200";
      case "info":
      default:
        return "bg-blue-50 border-blue-200";
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div
        className={`flex items-center p-4 rounded-lg shadow-lg border ${getBgColor()}`}
      >
        {getIcon()}
        <div className="ml-3 mr-6">{message}</div>
        <button
          onClick={() => setVisible(false)}
          className="p-1 rounded-full hover:bg-gray-200"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
